.lists {
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--paletteBlue0);
}

.subtitle {
  margin: 20px 0;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
  color: var(--paletteBlue0);
}

.description {
  margin-top: var(--spacingMd);
  word-break: "normal";
}
